// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"95906168","51":"787eb859","85":"aa0bdb82","369":"6de1099e","524":"f0f24d8d","614":"6dc74a62","697":"795cf332","899":"5267f6bd","928":"1c9dba2c","935":"4b6217d4"}[chunkId] + ".chunk.js";
};